module.exports = __webpack_public_path__ + "img/logoword_2.ab8f54f7.png";